
export default {
  cad: {
    id: 'cad',
    short: 'CA',
    name: 'Canadian Dollar',
    isZeroDecimal: false
  },
  // usd: {
  //   id: 'usd',
  //   name: 'US Dollar',
  //   isZeroDecimal: false
  // },
  // eur: {
  //   id: 'eur',
  //   name: 'Euro',
  //   isZeroDecimal: false
  // },
  // gbp: {
  //   id: 'gbp',
  //   name: 'British Pound',
  //   isZeroDecimal: false
  // },
  // jpy: {
  //   id: 'jpy',
  //   name: 'Yen',
  //   isZeroDecimal: true,
  // }
}
